import contract, { selectors } from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import button from './button.js'

export default contract({
  [selectors]: {
    'button[aria-checked]': array([
      button
    ])
  }
})
